import Flickity from 'flickity';

/**
 * Store Details Events
 * @param {object} opts
 */
function storeDetailsEvents(opts) {
  const config = {
    dom: {
      carousel: 'js-store-details-events-carousel',
      carousel_item: 'js-store-details-events-carousel-item',
      date: 'js-store-details-events-date',
      wrapper: 'js-store-details-events-carousel-wrapper',
    },
    cls: {
      active: 'is-active',
    },
  };
  const c = __.extend(config, opts);

  const flickityOpts = {
    contain: true,
    draggable: true,
    pageDots: true,
    prevNextButtons: true,
    wrapAround: true,
  };

  // global elements
  const $wrappers = document.body.querySelectorAll(`.${c.dom.wrapper}`);

  // global data
  const flickityCarousels = [];
  let view;

  /**
   * Init
   */
  function init() {
    onWindowResize();
    __.windowResize(onWindowResize);

    initDateDisplay();
  }

  /**
   * On Window Resize
   */
  function onWindowResize() {
    // desktop
    __.mq({
      view: 'desktop',
      callback: () => {
        if (view !== 'desktop') {
          view = 'desktop';
          rebuildFlickity();
        }
      },
    });

    // mobile
    __.mq({
      view: 'mobile',
      callback: () => {
        if (view !== 'mobile') {
          view = 'mobile';
          rebuildFlickity();
        }
      },
    });
  }

  /**
   * rebuild flickity
   */
  function rebuildFlickity() {
    if (!$wrappers?.length) return;
    const initCarouselCount = view === 'mobile' ? 2 : 3;
    flickityOpts.prevNextButtons = view !== 'mobile';
    flickityOpts.wrapAround = view !== 'mobile';

    [...$wrappers].forEach(($wrapper, index) => {
      const activeCarousel = flickityCarousels[index];
      if (activeCarousel) activeCarousel.destroy();
      const $carousel = $wrapper.querySelector(`.${c.dom.carousel}`);
      if (!$carousel) return;

      const $carouselItems = $carousel.querySelectorAll(`.${c.dom.carousel_item}`);
      if ($carouselItems.length < initCarouselCount) return;

      setTimeout(() => {
        const flickityCarousel = new Flickity($carousel, flickityOpts);

        if (activeCarousel) {
          flickityCarousels[index] = flickityCarousel;
        } else {
          flickityCarousels.push(flickityCarousel);
        }
      }, 500); // short timeout for Flickity cell sizing
    });
  }

  /**
   * Init Date Display
   */
  function initDateDisplay() {
    [...$wrappers].forEach(($wrapper) => {
      const $dateDisplays = $wrapper.querySelectorAll(`.${c.dom.date}`);
      if (!$dateDisplays?.length) return;

      $dateDisplays.forEach(($dateDisplay) => {
        const {
          startDate: startDateDataset,
          endDate: endDateDataset,
        } = $dateDisplay.dataset;
        if (!startDateDataset || !endDateDataset) return;

        const startDateObj = new Date(startDateDataset);
        const startDate = getDate(startDateObj);
        const startTime = getTime(startDateObj);

        const endDateObj = new Date(endDateDataset);
        const endDate = getDate(endDateObj);
        const endTime = getTime(endDateObj);

        const isSameDate = startDate === endDate;
        const dateDisplayText = isSameDate
          ? `${startDate} • ${startTime} - ${endTime}`
          : `${startDate} • ${startTime} - ${endDate} • ${endTime}`;

        $dateDisplay.innerHTML = dateDisplayText;
      });
    });
  }

  /**
   * Get Date
   * @param {Object} dateObj
   */
  function getDate(dateObj) {
    const month = getMonthName(dateObj.getMonth());
    const day = dateObj.getDate();
    const year = dateObj.getFullYear();

    return `${month} ${day}, ${year}`;
  }

  /**
   * Get Month Name
   * @param {Number} monthIndex
   */
  function getMonthName(monthIndex) {
    if (monthIndex === 0) return 'Jan';
    if (monthIndex === 1) return 'Feb';
    if (monthIndex === 2) return 'Mar';
    if (monthIndex === 3) return 'Apr';
    if (monthIndex === 4) return 'May';
    if (monthIndex === 5) return 'Jun';
    if (monthIndex === 6) return 'Jul';
    if (monthIndex === 7) return 'Aug';
    if (monthIndex === 8) return 'Sep';
    if (monthIndex === 9) return 'Oct';
    if (monthIndex === 10) return 'Nov';
    return 'Dec';
  }

  /**
   * Get Time
   * @param {Object} dateObj
   */
  function getTime(dateObj) {
    const amOrPm = dateObj.getHours() >= 12 ? 'pm' : 'am';

    let hour = dateObj.getHours() > 12
      ? dateObj.getHours() - 12
      : dateObj.getHours();
    if (hour === 0) hour = 12;

    let minutes = dateObj.getMinutes() < 10
      ? `0${dateObj.getMinutes()}`
      : dateObj.getMinutes();
    if (minutes === '00') minutes = '';

    return `${hour}${minutes ? `:${minutes}` : ''}${amOrPm}`;
  }

  return init();
}

export default storeDetailsEvents;
